// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Autoplay]);

var hpSwiper = new Swiper('#swiper-carousel-home', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-home-pagination',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-home-button-next',
        prevEl: '.swiper-home-button-prev',
    },

});

var reviewSwiper = new Swiper('#swiper-review', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: {
        delay: 8000,
        disableOnInteraction: true,
    },
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-review-pagination',
        clickable: true,
    },

});

var relatedNewsSwiper = new Swiper('#swiper-related-news', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-related-news-pagination',
        clickable: true,
    },

});

var partnerSwiper = new Swiper('#swiper-partner', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-partner-pagination',
        clickable: true,
    },

    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 4,
          spaceBetween: 40
        }
    }

});